import { render } from "./ExpertsTeaser.vue?vue&type=template&id=6e19b066"
import script from "./ExpertsTeaser.vue?vue&type=script&lang=js"
export * from "./ExpertsTeaser.vue?vue&type=script&lang=js"

import "./ExpertsTeaser.vue?vue&type=style&index=0&id=6e19b066&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__